// Firestore (~100 KB gzipped) and the SockJS/STOMP client are only used once a
// user is logged in (presence writes, notification listener, chat socket), but
// UserContext wraps every page. Imported statically, they shipped to every
// logged-out visitor and every crawler on every public page - the heaviest
// chunk on the SEO pages. Loading them on demand keeps them out of the shared
// bundle. Each loader memoises its promise, so the modules load once.

let firestorePromise
export const loadFirestore = () => {
    if (!firestorePromise) {
        firestorePromise = Promise.all([
            import('@firebase/firestore'),
            import('../firebase'),
        ]).then(([firestore, { db }]) => ({
            db,
            doc: firestore.doc,
            setDoc: firestore.setDoc,
            onSnapshot: firestore.onSnapshot,
            serverTimestamp: firestore.serverTimestamp,
        }))
    }
    return firestorePromise
}

let stompPromise
export const loadStomp = () => {
    if (!stompPromise) {
        stompPromise = Promise.all([
            import('sockjs-client'),
            import('stompjs'),
        ]).then(([sockjs, stomp]) => ({
            SockJS: sockjs.default ?? sockjs,
            Stomp: stomp.default ?? stomp,
        }))
    }
    return stompPromise
}
